import { computed } from 'vue';
import { IValidationInfoDates, ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import datePresenter from'@/presenters/date-presenter';
import store from '@/store';

export default class DurationCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.START_DATE)
			|| validationPresenter.isPropertyMissing(ValidationProperties.END_DATE);
	});

	public isFieldValidatedAndInvalid = computed((): boolean => {
		return this.validationInfoDates.value.invalidTypes.length !== 0;
	});

	public validationInfoDates = computed((): IValidationInfoDates => {
		return store.getters.validationInfoDates();
	});

	public datesDisabledMessage = computed((): string => {
		const shouldStartDateBeDisabled = datePresenter.shouldStartDateBeDisabled.value;
		const shouldEndDateBeDisabled = datePresenter.shouldEndDateBeDisabled.value;

		if (shouldStartDateBeDisabled && shouldEndDateBeDisabled) {
			return 'The start and end date have already passed and can no longer be changed.';
		}

		if (shouldStartDateBeDisabled) {
			return 'The start date has already passed and can no longer be changed.';
		}

		if (shouldEndDateBeDisabled) {
			return 'The end date has already passed and can no longer be changed.';
		}

		return '';
	});
}
